import React from 'react'

import EditSubscriptionForm from '../../modules/Subscription/components/EditSubscriptionForm'
export default function EditSubscriptionPage() {
  return <EditSubscriptionForm />
}
